import { ConstanteGlobal } from "../config/constanteGlobal";
import { FiltroBasico } from "../models/basico";
import { ModeloSopProductFamily } from "../models/sopProductFamily";
import { Repositorio } from "./repositorio";

export class FiltroSopBusinesUnit extends FiltroBasico<ModeloSopProductFamily> implements Partial<ModeloSopProductFamily> {
  
}

export class RepositorioSopProductFamily extends Repositorio<ModeloSopProductFamily> {
  constructor() {
    super(ConstanteGlobal.SOP_PRODUCT_FAMILY);
  }
}
